// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"141":"booking-create","466":"booking-detail","805":"booking-list"}[chunkId] + "." + {"141":"d233dd0a","466":"b6ac7fac","805":"5cca15e9"}[chunkId] + ".css";
};